/* eslint react/no-array-index-key: 0 */
import React from 'react'
import {
  Formik,
  Form,
  FieldArray,
} from 'formik'

import {
  FormWrapper,
  NewCallWaiterButton,
  SubmitButton,
  CallWaiterWrapper,
} from './styles'
import Icon from '../../../../../components/icon'
import FieldGroup from '../../../../../components/form/form-factory/field-group'
import FormActions from './form-actions'

const FieldArrayComponent = FieldArray as any

const templateForm = {
  option: '',
  kind: [],
}

const CallWaiterForm = ({
  dataForm,
  initialData,
  onSubmit,
  isToUpdate = false,
}: any) => {
  const initialValues = initialData || { callWaiters: [{ ...templateForm }] }

  const handleActivationUpdate = (
    actions: any,
    fieldname: string,
    value: boolean,
  ) => {
    if (actions.setFieldValue) {
      actions.setFieldValue(fieldname, !value)
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {(actions) => (
        <Form>
          <FieldArrayComponent name="callWaiters">
            {({ remove, push }: any) => (
              <FormWrapper>
                <NewCallWaiterButton
                  type="button"
                  onClick={() => push(templateForm)}
                >
                  <Icon name="plus" />
                  <span>Nova opção</span>
                </NewCallWaiterButton>
                {actions.values.callWaiters.length > 0
                  && actions.values.callWaiters.map((callWaiter: any, index: number) => (
                    <div className="row" key={index}>
                      <CallWaiterWrapper>
                        <FormActions
                          hasDeleteButton={!isToUpdate}
                          handleActivationUpdate={
                            () => handleActivationUpdate(
                              actions,
                              `callWaiters.${index}.isActive`,
                              actions.values.callWaiters[index].isActive,
                            )
                            }
                          active={actions.values.callWaiters[index].isActive}
                          remove={() => remove(index)}
                        />
                        <div style={{ padding: 16 }}>
                          <FieldGroup
                            prefixName={`callWaiters.${index}.`}
                            actions={actions}
                            data={dataForm}
                          />
                        </div>
                      </CallWaiterWrapper>
                    </div>
                  ))}
              </FormWrapper>
            )}
          </FieldArrayComponent>
          <SubmitButton type="submit">
            { actions.isSubmitting ? 'Salvando...' : 'Salvar' }
          </SubmitButton>
        </Form>
      )}
    </Formik>
  )
}

export default CallWaiterForm
